/* eslint-disable no-param-reassign,@typescript-eslint/no-unused-expressions,@typescript-eslint/no-unused-vars */

(function (angular) {
  angular.module('xplenty-designer').factory('DesignerAmazonRedshiftDestinationComponent', [
    '$rootScope',
    'DesignerBaseDatabaseDestinationComponent',

    function ($rootScope, DesignerBaseDatabaseDestinationComponent) {
      function DesignerAmazonRedshiftDestinationComponent() {
        DesignerBaseDatabaseDestinationComponent.apply(this);

        this.intermediate_compression_type;
        this.date_format;
        this.time_format;
        this.empty_as_null;
        this.blank_as_null;
        this.null_string;
        // this.replacement_character;
        this.trim_blanks;
        this.max_errors;
        this.explicit_ids;
        this.truncate_columns;
        this.round_decimals;
        this.replacement_char;
        this.comp_update;
        this.comp_rows;
      }

      DesignerAmazonRedshiftDestinationComponent.prototype = new DesignerBaseDatabaseDestinationComponent();

      DesignerAmazonRedshiftDestinationComponent.prototype.getData = function () {
        const data = DesignerBaseDatabaseDestinationComponent.prototype.getData.call(this);

        _.extend(data, {
          intermediate_compression_type: angular.isDefined(this.intermediate_compression_type)
            ? this.intermediate_compression_type
            : this.defaults.intermediate_compression_type,
          date_format: this.date_format || this.defaults.date_format,
          time_format: this.time_format || this.defaults.time_format,
          empty_as_null: angular.isDefined(this.empty_as_null) ? this.empty_as_null : this.defaults.empty_as_null,
          blank_as_null: angular.isDefined(this.blank_as_null) ? this.blank_as_null : this.defaults.blank_as_null,
          null_string: this.null_string || this.defaults.null_string,
          // replacement_character: angular.isDefined(this.replacement_character) ? this.replacement_character : this.defaults.replacement_character,
          trim_blanks: angular.isDefined(this.trim_blanks) ? this.trim_blanks : this.defaults.trim_blanks,
          max_errors: this.max_errors || this.defaults.max_errors,
          explicit_ids: angular.isDefined(this.explicit_ids) ? this.explicit_ids : this.defaults.explicit_ids,
          truncate_columns: angular.isDefined(this.truncate_columns)
            ? this.truncate_columns
            : this.defaults.truncate_columns,
          round_decimals: angular.isDefined(this.round_decimals) ? this.round_decimals : this.defaults.round_decimals,
          replacement_char: angular.isDefined(this.replacement_char)
            ? this.replacement_char
            : this.defaults.replacement_char,
          comp_update: this.comp_update || this.defaults.comp_update,
          comp_rows: this.comp_rows || this.defaults.comp_rows,
        });

        return data;
      };

      DesignerAmazonRedshiftDestinationComponent.prototype.setFormData = function (data) {
        if (data.operation_type === 'merge_update_and_insert' || data.operation_type === 'merge') {
          data.explicit_ids = false;
        }

        this.setData(data);

        DesignerBaseDatabaseDestinationComponent.prototype.setFormData.call(this, data);
      };

      DesignerAmazonRedshiftDestinationComponent.prototype.setData = function (data) {
        this.date_format = data.date_format;
        this.time_format = data.time_format;
        this.empty_as_null = data.empty_as_null;
        this.blank_as_null = data.blank_as_null;
        this.null_string = data.null_string;
        this.intermediate_compression_type = data.intermediate_compression_type;
        // this.replacement_character = data.replacement_character;
        this.trim_blanks = data.trim_blanks;
        this.max_errors = data.max_errors;
        this.explicit_ids = data.explicit_ids;
        this.truncate_columns = data.truncate_columns;
        this.round_decimals = data.round_decimals;
        this.replacement_char = data.replacement_char;
        this.comp_update = data.comp_update;
        this.comp_rows = data.comp_rows;

        DesignerBaseDatabaseDestinationComponent.prototype.setData.call(this, data);
      };

      return DesignerAmazonRedshiftDestinationComponent;
    },
  ]);
})(window.angular);
